var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"align-end":"","justify-center":"","text-xs-center":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"100px"},attrs:{"xs12":""}},[_c('img',{staticClass:"imge",attrs:{"src":require("../assets/logo.png")}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }